import { plainAxiosInstance, securedAxiosInstance } from "../axios";

class UserService {
  getUser() {
    return plainAxiosInstance.get("/user");
  }

  updatePassword({ oldPassword, newPassword, newPasswordConfirmation }) {
    return securedAxiosInstance.put("/user/passwords", {
      old_password: oldPassword,
      password: newPassword,
      password_confirmation: newPasswordConfirmation,
    });
  }

  forgotPassword(email) {
    return plainAxiosInstance.get("/user/password_resets/new", { params: { email } });
  }
}

export default new UserService();
